import { sendToGTM } from '../context/utils/GoogleTagManager';
import { trackingStatusGet, trackingStatusSet } from '../util/trackingStatus';

var logoutEvent = function logoutEvent() {
  var event = {
    event: 'logout',
    detailed_event: 'Logout',
    event_data: {
      method: 'web'
    },
    page_data: {
      user_login_state: 'Unauthenticated'
    }
  };
  sendToGTM({
    data: event
  });
};

export var logoutEventDetect = function logoutEventDetect() {
  var previousVal = trackingStatusGet('user_login_state');

  if (previousVal === 'Authenticated') {
    logoutEvent();
  }

  if (previousVal !== 'Unauthenticated') {
    trackingStatusSet('user_login_state', 'Unauthenticated');
  }
};